import {Component, EventEmitter, Output, ViewChild} from '@angular/core';

import {CaseIncome} from '../case-income';
import {CaseIncomeService} from '../case-income.service';

@Component({
  selector: 'app-case-income-create',
  templateUrl: 'create.component.html',
})
export class CaseIncomeCreateComponent {
  @ViewChild('staticModal') staticModal;

  @Output() completed = new EventEmitter<boolean>();

  public disabled: boolean = false;

  public model: CaseIncome = new CaseIncome();

  private givenCaseId: string;

  constructor(private readonly caseIncomeService: CaseIncomeService) {}

  public get caseId(): string {
    return this.givenCaseId;
  }

  public open(caseId: string): void {
    this.givenCaseId = caseId;
    this.staticModal.show();
  }

  public close() {
    this.workCompleted();
  }

  public confirmCreate($event) {
    $event.preventDefault();
    this.disabled = true;
    this.caseIncomeService
      .createCaseIncome(this.model, { parameters: { id: this.caseId } })
      .subscribe(() => {
        this.workCompleted();
      });
  }

  private workCompleted() {
    this.model = new CaseIncome();
    this.disabled = false;
    this.staticModal.hide();
    this.completed.next(true);
  }
}
